const cols = [
  {
    heading: "Services",
    items: ["Positioning", "Performance", "Precision"],
  },
  {
    heading: "Who We Serve",
    items: ["Universities", "EdTech Brands", "Upskilling Companies", "Learner Communities"],
  },
  {
    heading: "Company",
    items: ["Process", "Founder", "Case Studies"],
  },
];

export const Footer = () => {
  return (
    <footer className="bg-[#2F3E63] text-[#FAF7F2] border-t border-[#FAF7F2]/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
         <a
  href="#top"
  className="inline-flex items-center justify-center bg-white rounded-full px-5 py-2.5 shadow-[0_8px_24px_rgba(0,0,0,0.15)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_14px_32px_rgba(0,0,0,0.2)]"
>
  <img
    src="/Logo.svg"
    alt="DOMINATE"
    className="h-7 w-auto"
  />
</a>
          <p className="mt-5 text-sm text-[#FAF7F2]/55 leading-relaxed max-w-xs">
            A growth marketing consultancy helping education brands become the top choice for learners.
          </p>
        </div>

        {cols.map((c) => (
          <div key={c.heading}>
            <div className="eyebrow text-[#FF6A3D] mb-5">{c.heading}</div>
            <ul className="space-y-3">
              {c.items.map((i) => (
                <li key={i}>
                  <span className="text-sm text-[#FAF7F2]/65 hover:text-[#FAF7F2] transition-colors cursor-default">{i}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-[#FAF7F2]/10">
<div className="max-w-4xl mx-auto px-6 py-24 flex flex-col items-center text-center">          <div className="font-display font-bold tracking-tight text-sm text-[#FAF7F2]/50">
            DOMINATE — Growth for Education Brands
          </div>
          <div className="text-xs text-[#FAF7F2]/40">
            &copy; {new Date().getFullYear()} DOMINATE. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};
